import { useRequesterStore } from '../stores/requester'
let requesterX: any
export async function send(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/chat/send`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function transcript(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/chat/transcript`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function sendImageAPI(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/chat/send-image`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
